import {
  CalendarEventStatus,
  isCalendarEventStarted,
  isDefaultAttachment,
} from 'mapistry-shared';
import React from 'react';
import EventChoiceMenu from '../CalendarCard/EventChoiceMenu';

export const InspectionEventChoiceMenu = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  menuAnchor,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  eventChoices,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onEventClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  closeEventChoiceMenu,
}) => {
  const formatDate = (date) => {
    const abbreviatedMonths = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'June',
      'July',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ];
    return `${
      abbreviatedMonths[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
  };

  const inspectionDescription = (event) => {
    const { status } = event;
    const isStarted = isCalendarEventStarted(event);
    const startedText = isStarted ? ' and started' : '';

    switch (status) {
      case CalendarEventStatus.COMPLETE:
        return `(completed)`;
      case CalendarEventStatus.EXCEPTION:
        return `(exception recorded)`;
      case CalendarEventStatus.OVERDUE:
        return `(overdue${startedText})`;
      case CalendarEventStatus.UPCOMING:
        return `(due soon${startedText})`;
      case CalendarEventStatus.AS_NEEDED:
      case CalendarEventStatus.NOT_NEEDED:
      case CalendarEventStatus.EXTRA:
      default:
        return isStarted ? '(started)' : '';
    }
  };

  const getAsNeededItemText = (calendarEvent) => {
    const description = inspectionDescription(calendarEvent);
    const existingEventText = `Inspection #${calendarEvent.eventNumber} ${description}`;
    const itemText = isDefaultAttachment(calendarEvent.attachments[0])
      ? 'Create a new inspection'
      : existingEventText;

    return itemText;
  };

  const getRecurringEventItemText = (calendarEvent) => {
    const { eventNumber, dueDate } = calendarEvent;
    const formattedDueDate = formatDate(dueDate);
    const description = inspectionDescription(calendarEvent);

    return `Inspection #${eventNumber} - Due Date: ${formattedDueDate} ${description}`;
  };

  return (
    <EventChoiceMenu
      eventChoices={eventChoices}
      menuAnchor={menuAnchor}
      onClose={closeEventChoiceMenu}
      onEventClick={onEventClick}
      getAsNeededItemText={getAsNeededItemText}
      getRecurringEventItemText={getRecurringEventItemText}
    />
  );
};
